const translations = {
  "en": {
    "No additional content available.": "No additional content available.",
    "TL;DR": "TL;DR"
  },
  "zh-tw": {
    "No additional content available.": "暫無其他內容",
    "TL;DR": "TL;DR"
  }
};

export default translations;
